import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Box, Button, Container, Link, Paper, Stack, Typography } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'
import { TERMS_SECTIONS, TERMS_UPDATED } from '../constants/legal'
import { textWithLinks } from '../service/terms'

// A Terms paragraph, with [text](/path) rendered as a link to that page of the site.
export function LinkedParagraph ({ text }) {
  return (
    <Typography variant="body1" color="text.secondary">
      {textWithLinks(text).map((part, index) => typeof part === 'string'
        ? <React.Fragment key={index}>{part}</React.Fragment>
        : <Link key={index} component={RouterLink} to={part.to}>{part.text}</Link>)}
    </Typography>
  )
}

LinkedParagraph.propTypes = {
  text: PropTypes.string.isRequired
}

// Public page: reachable without signing in so the sign-up form and upload
// form can link to it.
export default function Terms () {
  useEffect(() => {
    const previous = document.title
    document.title = 'Terms of Use · Highlights'
    return () => { document.title = previous }
  }, [])

  return (
    <Container maxWidth="md" sx={{ py: { xs: 3, md: 6 } }}>
      <Paper variant="outlined" sx={{ p: { xs: 2.5, md: 4 } }}>
        <Stack spacing={3}>
          <Box>
            <Typography variant="overline" color="text.secondary">Highlights</Typography>
            <Typography variant="h4" component="h1" sx={{ fontWeight: 800 }}>
              Terms of Use and Disclaimer
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Last updated {TERMS_UPDATED}
            </Typography>
          </Box>
          {TERMS_SECTIONS.map(section => (
            <Box key={section.title} component="section">
              <Typography variant="h6" component="h2" sx={{ fontWeight: 700, mb: 1 }}>
                {section.title}
              </Typography>
              <Stack spacing={1}>
                {section.body.map(paragraph => <LinkedParagraph key={paragraph} text={paragraph} />)}
              </Stack>
            </Box>
          ))}
          <Box>
            <Button component={RouterLink} to="/" variant="outlined">
              Go to Highlights
            </Button>
          </Box>
        </Stack>
      </Paper>
    </Container>
  )
}
